<script>
import { useI18n } from 'vue-i18n';
import feather from 'feather-icons';
import ProjectSingle from './ProjectSingle.vue';
import ProjectModal from './ProjectModal.vue';
import projects from '../../data/projects';

export default {
	components: { ProjectSingle, ProjectModal },
	setup() {
		const { t, locale } = useI18n();
		return { t, locale };
	},
	data: () => {
		return {
			selectedCategory: '',
			searchProject: '',
			isModalOpen: false,
			selectedProject: null,
		};
	},
	computed: {
		projects() {
			return projects.listproject;
		},
		// Get the filtered projects
		filteredProjects() {
			let filtered = this.projects;

			// Filter by selected category
			if (this.selectedCategory) {
				filtered = filtered.filter((item) => {
					let category =
						item.category.charAt(0).toUpperCase() +
						item.category.slice(1);
					return category.includes(this.selectedCategory);
				});
			}

			// Filter by search
			if (this.searchProject) {
				let project = new RegExp(this.searchProject, 'i');
				filtered = filtered.filter((el) => el.title.match(project));
			}

			// Get the latest starred projects, up to 5 items
			return filtered.filter((item) => item.stars === 'yes').slice(0, 5);
		},
	},
	mounted() {
		feather.replace();
	},
	methods: {
		// Filter projects by category
		filterProjectsByCategory() {
			return this.projects.filter((item) => {
				let category =
					item.category.charAt(0).toUpperCase() +
					item.category.slice(1);
				console.log(category);
				return category.includes(this.selectedCategory);
			});
		},
		// Filter projects by title search
		filterProjectsBySearch() {
			let project = new RegExp(this.searchProject, 'i');
			return this.projects.filter((el) => el.title.match(project));
		},
		// Open modal with project details
		openModal(project) {
			this.selectedProject = project;
			this.isModalOpen = true;
		},
		// Close modal
		closeModal() {
			this.isModalOpen = false;
			this.selectedProject = null;
		},
	},
};
</script>

<template>
  <!-- Projects grid -->
  <section class="pt-10 sm:pt-14">
    <!-- Projects grid title -->
    <div class="text-center">
      <p
        class="font-general-semibold text-2xl sm:text-5xl font-semibold mb-10 text-ternary-dark dark:text-ternary-light"
      >
        {{ t('projects.titlehome') }}
      </p>
    </div>

    <!-- Projects grid -->
    <div
      class="grid grid-cols-1 sm:grid-cols-3 mt-6 sm:gap-10"
    >
      <ProjectSingle
        v-for="project in filteredProjects"
        :key="project.id"
        :project="project"
        @click="openModal(project)"
      />

			<router-link
				v-if="filteredProjects.length === 5"
				to="/projects"
				class="min-h-full mb-10 sm:mb-0 rounded-xl shadow-lg hover:shadow-xl bg-secondary-light dark:bg-ternary-dark transition-transform duration-200 hover:scale-[1.01] flex items-center justify-center p-6"
			>
				<div class="text-center">
					<span class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-dark text-white dark:bg-primary-light dark:text-primary-dark">
						<i data-feather="arrow-right" class="h-6 w-6" />
					</span>
					<span class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light">
						{{ t('home.loadProjectMore') }}
					</span>
				</div>
			</router-link>
    </div>

    <!-- Project Modal -->
    <ProjectModal
      v-if="selectedProject"
      :project="selectedProject"
      :is-open="isModalOpen"
      @close="closeModal"
    />
  </section>
</template>

<style scoped></style>
